import { t } from 'src/i18n';
import { EmptyWrapper } from './globalSearchEmpty.style';

const GlobalSearchEmpty = () => {
  return (
    <EmptyWrapper>
      <h1 className="search-empty-title">{t('dash.globalSearch.no_results')}</h1>
      <p className="search-empty-message">{t('dash.globalSearch.no_results_message_with_invoices')}</p>
    </EmptyWrapper>
  );
};

export default GlobalSearchEmpty;
